// Firebase Web SDK initialisation for Angiolini VIP Club.
// Used for FCM web push notifications.
import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export function getFirebaseApp() {
  return getApps()[0] || initializeApp(firebaseConfig);
}

let _messaging = null;
let _supportChecked = false;
let _supported = false;

export async function getFcmMessaging() {
  if (!_supportChecked) {
    try {
      _supported = await isSupported();
    } catch {
      _supported = false;
    }
    _supportChecked = true;
  }
  if (!_supported) return null;
  if (_messaging) return _messaging;
  _messaging = getMessaging(getFirebaseApp());
  return _messaging;
}

/**
 * Register the FCM service worker, request notification permission, and
 * retrieve a token. Returns the token string on success, null on failure.
 */
export async function requestFcmToken() {
  try {
    if (typeof window === "undefined" || !("serviceWorker" in navigator) || !("Notification" in window)) {
      return null;
    }
    const messaging = await getFcmMessaging();
    if (!messaging) return null;

    // Register service worker (must be in /public)
    const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });
    return token || null;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("FCM token request failed", e);
    return null;
  }
}

/**
 * Listen for foreground messages. Returns the unsubscribe function.
 */
export async function onForegroundMessage(callback) {
  const messaging = await getFcmMessaging();
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}
